module.exports = __webpack_public_path__ + "img/citi.7a6ef959.svg";